import emailsStore from "@/app/emailsManager/store/emails";

export default {
  modules: {
    emailsStore,
  },
};
